import { useEffect } from "react";
import { FAQ_CATEGORIES } from "@/data/site";

/**
 * Injects a single FAQPage JSON-LD into <head> built from FAQ_CATEGORIES.
 * Picks up to 12 top questions across categories · Google requires the same
 * Q/A text to be visible on the page (which they are inside the FAQ accordion).
 */
export default function FaqJsonLd() {
  useEffect(() => {
    const top = [];
    for (const cat of FAQ_CATEGORIES) {
      for (const it of cat.items) {
        top.push(it);
        if (top.length >= 12) break;
      }
      if (top.length >= 12) break;
    }
    const payload = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: top.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    };
    const ID = "faq-json-ld";
    let el = document.getElementById(ID);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = ID;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(payload);
    return () => { if (el && el.parentNode) el.parentNode.removeChild(el); };
  }, []);
  return null;
}
